module.exports = __webpack_public_path__ + "img/qr-icon.c13d9182.png";